import React from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import Text from '~/components/core/TextComponents/Text';
import cn from '~/Utils/cn';

import { STATUS_FILTERS } from '../constants';
import type { StatusFilter } from '../types';

interface StatusFilterBarProps {
  value: StatusFilter;
  onChange: (status: StatusFilter) => void;
}

/**
 * Level two of the panel's filter: does it need anybody.
 *
 * The plainest control on the pane — text, the active option underlined, no colour and no icons —
 * so it cannot be read as a second row of the kind chips above it.
 */
const StatusFilterBar: React.FC<StatusFilterBarProps> = ({ value, onChange }) => (
  <div role="group" aria-label="Status" className="flex items-baseline gap-12">
    <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
      Status
    </Text>
    {STATUS_FILTERS.map(({ value: status, label }) => {
      const isActive = status === value;

      return (
        <Button
          key={status}
          variant="text"
          disableRipple
          aria-pressed={isActive}
          onClick={() => onChange(status)}
          className={cn('min-w-0 p-0 normal-case text-slate-800 underline-offset-4 hover:bg-transparent', {
            underline: isActive,
          })}
        >
          <Text variant={Text.VARIANTS.XS} weight={isActive ? Text.WEIGHTS.SEMI_BOLD : Text.WEIGHTS.REGULAR}>
            {label}
          </Text>
        </Button>
      );
    })}
  </div>
);

export default StatusFilterBar;
